import { atom } from 'recoil';

export const fontScaleState = atom({
  key: 'fontScaleState',
  default: Number(localStorage.getItem('fontScale')),
});
